import { render, staticRenderFns } from "./PostalCodeSearch.vue?vue&type=template&id=9e50f9f4&"
import script from "./PostalCodeSearch.vue?vue&type=script&lang=js&"
export * from "./PostalCodeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports